import React from 'react';

class Score extends React.Component {
    render(){
    return (<p>Score</p>);
    }
}

export default Score;